import { type UseQueryResult, useQuery } from 'react-query';
import { MoneyEntitlementService } from '../../services/wealthlane-award-settlement-services/services/MoneyEntitlementService';
import { Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto } from '../../services/wealthlane-award-settlement-services/models/Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto';

const useGetMoneyEntitlementExistingSetup = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto[] | undefined,
  unknown
> => {
  const moneyEntitlementExistingSetup = useQuery(['getMoneyEntitlementExistingSetup'], async () => {
    return await handleRequest(
      MoneyEntitlementService.getApiAwardSettlementApiMoneyEntitlementsExistingSetup()
    );
  });

  return moneyEntitlementExistingSetup;
};

export default useGetMoneyEntitlementExistingSetup;
